export default {"src":"/_next/static/media/location-maincolor.4cd82a6f.svg","height":18,"width":13,"blurWidth":0,"blurHeight":0};